<template>
    <div class="body d-flex pb-lg-3">
        <div class="container-xxl">
            <div class="row clearfix">
                <div class="col-md-12">
                        <div class="d-sm-flex align-items-end justify-content-end main-button-area justify-content-center-mob">
                            <!-- Button to mark all notifications as read -->
                            <button class="btn btn-primary" @click="markAllAsRead">ΕΠΙΣΗΜΑΝΣΗ ΟΛΩΝ ΩΣ ΑΝΑΓΝΩΣΜΕΝΑ</button>
                        </div>
                </div>
            </div>

            <!-- Tabs for Read and Unread Notifications -->
            <div class="row my-4">
                <div class="col-md-12">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link fw-bolder" :class="{ active: isUnreadActive }" @click="setUnreadFilter">Μη Αναγνωσμένα</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link fw-bolder" :class="{ active: isReadActive }" @click="setReadFilter">Αναγνωσμένα</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="card-body table-responsive">
                <table id="notificationTable" class="table table-hover align-middle mb-0 w-100">
                    <thead>
                        <tr class="title-wrap">
                            <th>
                                <div class="date-title">
                                    Ημερομηνια
                                </div>
                            </th>
                            <th class="text-end">
                                <div class="description-title">
                                    Περιγραφή
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="data-wrap" v-for="(notification, index) in data" :key="notification.id">
                            <td class="created-at" v-html="notification.created_at"></td>
                            <td class="d-flex justify-content-end description"  v-html="notification.description"></td>
                        </tr>
                        <tr class="col" v-if="!data || !data.length">
                            <td class="text-left" colspan="1">Δεν βρέθηκαν δεδομένα</td>
                        </tr>
                    </tbody>
                </table>
                <nav aria-label="Page navigation" v-if="data && data.length">
                    <ul class="pagination mt-4 d-flex align-items-center" v-if="paginationLinks && paginationLinks.length > 0">
                    <!-- Previous button -->
                    <li class="page-item" :class="{ disabled: !paginationLinks[0].url }">
                        <router-link 
                            v-if="paginationLinks[0].url" 
                            :to="{ path: 'notifications-municipality', query: { ...filters, page: getPageFromUrl(paginationLinks[0].url) } }" 
                            class="btn btn-outline-primary"
                        >
                            <i class="icofont-arrow-left"></i>
                        </router-link>
                        <span class="btn btn-outline-primary " v-else>
                            <i class="icofont-arrow-left"></i>
                        </span>
                    </li>

                    <!-- Page numbers -->
                    <li class="page-item ms-2" 
                        v-for="(paginationLink, index) in paginationLinks.slice(1, paginationLinks.length - 1)" 
                        :key="index" 
                        :class="{ active: paginationLink.active }"
                    >
                        <router-link 
                            v-if="paginationLink.url" 
                            :to="{ path: 'notifications-municipality', query: { ...filters, page: getPageFromUrl(paginationLink.url) } }" 
                            class="page-link rounded"
                            v-html="paginationLink.label"
                        ></router-link>
                        <span class="page-link" v-else v-html="paginationLink.label"></span>
                    </li>

                    <!-- Next button -->
                    <li class="page-item ms-2" :class="{ disabled: !paginationLinks[paginationLinks.length - 1].url }">
                        <router-link 
                            v-if="paginationLinks[paginationLinks.length - 1].url" 
                            :to="{ path: 'notifications-municipality', query: { ...filters, page: getPageFromUrl(paginationLinks[paginationLinks.length - 1].url) } }" 
                            class="btn btn-primary text-white"
                        >
                            Επόμενη σελίδα >
                        </router-link>
                        <span class="btn btn-primary text-white" v-else>
                            Επόμενη σελίδα >
                        </span>
                    </li>
                </ul>
            </nav>
            </div>
        </div>

        <!-- Notification Modal -->
        <div class="modal fade" id="notificationModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold" id="notificationModalLabel">{{ isUpdate ? 'Update Notification' : 'Create Notification' }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="submitNotification">
                            <div class="mb-3">
                                <label for="description" class="form-label">Περιγραφή</label>
                                <textarea v-model="notificationForm.description" id="description" class="form-control" required></textarea>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Ακύρωση</button>
                                <button type="submit" class="btn btn-primary">{{ isUpdate ? 'Update' : 'Create' }}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Confirmation Modal -->
        <!-- <div class="modal fade" id="confirmationModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold" id="confirmationModalLabel">Confirm Action</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p>{{ confirmationMessage }}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="submitAction">Submit</button>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>


<script setup>
    import { ref, onMounted, onUnmounted } from 'vue';
    import { fetchAll, createNotification, updateNotification, deleteNotification, markAllNotificationsRead } from '@/services/notifications';
    import { useRoute, useRouter } from 'vue-router';
    import { useFetchData } from '@/composables/useFetchData';
    import { useToast } from 'vue-toastification';
    import { useHead } from '@vueuse/head';

    const route = useRoute();
    const router = useRouter();

    const { data, paginationLinks, fetchData, filters, updateFilters } = useFetchData(
        fetchAll,
        { page: route.query.page || 1, unread: route.query.unread || null, read: route.query.read || null },
        { page: 1, unread: 1, read: null }
    );

    // const confirmationMessage = ref('');
    const notificationToActOn = ref(null);
    const isUpdate = ref(false);
    const isUnreadActive = ref((route.query.unread == '1') || (route.query.read == null));
    const isReadActive = ref((route.query.read == '1'));

    const notificationForm = ref({
        description: ''
    });

    const setUnreadFilter = () => {
        isUnreadActive.value = true;
        isReadActive.value = false;
        updateFilters({ ...filters.value, unread: 1, read: null });
    };

    const setReadFilter = () => {
        isUnreadActive.value = false;
        isReadActive.value = true;
        updateFilters({ ...filters.value, read: 1, unread: null });
    };

    const markAllAsRead = async () => {
        try {
            const notificationIds = data.value.map(notification => notification.id);
            const r = await markAllNotificationsRead({ ids: notificationIds });
            if (r.data.success) {
                useToast().success(r.data.message);
                fetchData();
            } else {
                useToast().error(r.data.message);
            }
        } catch (error) {
            useToast().error("Failed to mark notifications as read.");
        }
    };

    const submitNotification = async () => {
        let response;
        if (isUpdate.value) {
            response = await updateNotification(notificationToActOn.value.id, notificationForm.value);
        } else {
            response = await createNotification(notificationForm.value);
        }

        if (response.data.success) {
            useToast().success(response.data.message);
            fetchData();
            $('#notificationModal').modal('hide');
        } else {
            useToast().error(response.data.message);
        }
    };

    // const submitAction = async () => {
    //     const r = await deleteNotification(notificationToActOn.value.id);
    //     if (r.data.success) {
    //         useToast().success(r.data.message);
    //         fetchData();
    //     } else {
    //         useToast().error(r.data.message);
    //     }
    //     $('#confirmationModal').modal('hide');
    // };

    const getPageFromUrl = (url) => {
        if (!url) return null;
        const urlObj = new URL(url, window.location.origin);
        return urlObj.searchParams.get('page');
    };

    const searchAction = () => {
        setTimeout(() => {
            router.push({ path: '/notifications-municipality', query: { ...route.query, search: $("#main-search-input").val() } });
        }, 300);
    };

    onMounted(() => {
        useHead({
            title: 'Ειδοποιήσεις - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισητηρίου',
            meta: [
                { name: 'description', content: 'Ειδοποιήσεις - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισητηρίου' },
                { property: 'og:title', content: 'Ειδοποιήσεις - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισητηρίου' },
                { property: 'og:description', content: 'Ειδοποιήσεις - Πλατφόρμα Διαχείρισης Ηλεκτρονικού Εισητηρίου' }
            ]
        });
        $(document.body).on('keyup', "#main-search-input", searchAction).on('click', "#main-search-input", searchAction);
    });

    onUnmounted(() => {
        $(document.body).off('keyup', "#main-search-input", searchAction).off('click', "#main-search-input", searchAction);
        $("#main-search-input").val("");
    });
</script>


<style scoped>

    .nav-link{
        color:#3a3a3a;
    }

    .nav-link:hover{
        cursor:pointer;
        color:#E8A31B;
    }

    .btn-outline-primary:hover{
        background-color: red;
    }

    .nav-tabs{
        border-bottom: 1px solid #dee2e6;
    }

    .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
        background-color: var(--primary-color);
        border-color: var(--primary-color);
        color: var(--white-color);
    }

    .created-at{
        font-size: 16px;
        border-bottom: 1px solid lightgray;
        font-weight: 500;
    }   

    .description{
        font-size: 16px;
        font-weight: 500;
    }

    .date-title,
    .description-title{
        font-size: 18px;
        font-weight: 600;
    }

    .title-wrap,
    .data-wrap{
        border-bottom: 1px solid lightgray;
    }


  @media (max-width: 576px){
    .description{
        font-size: 13px;
    }

  }
</style>
